import { render, staticRenderFns } from "./PartSupplierPrice.vue?vue&type=template&id=61705e2f"
import script from "./PartSupplierPrice.vue?vue&type=script&lang=js"
export * from "./PartSupplierPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports